import { Tabs, Tab, Box, Stepper, Step, StepLabel, styled } from "@mui/material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Custom connector to make the line thinner and gray
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#004A99', // Matches your primary blue
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#004A99',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const steps = [
  { label: "Settings", path: "settings" },
  { label: "Companies", path: "companies" },
  { label: "Report", path: "report" }
];

export default function RequestSettingsTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { companyId } = useParams();
  const currentTab = location.pathname.split("/")[3] || "settings";

/*   const handleChange = (_, newValue) => {
    navigate(`/company/${companyId}/${newValue}`);
  }; */

  const handleChange = (_, newValue) => {
  // Use the optional second argument to pass the current state
  navigate(`/grade-reports/${companyId}/request-settings/${newValue}`, { 
    state: location.state 
  });
};

  let activeStep = 0;

  return (
    <Box sx={{ width: "100%", maxWidth: "800px", margin: "0 auto", mb: 6, mt: 2 }}>
          <Stepper 
            activeStep={activeStep} 
            connector={<QontoConnector />}
            alternativeLabel // This puts labels under the icons for a cleaner look
          >
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  onClick={() => navigate(`/grade-reports/${companyId}/request-settings/${step.path}`)}
                  StepIconProps={{
                    sx: {
                      cursor: "pointer",
                      // Style the circle icons
                      '&.Mui-active': { color: '#004A99' },
                      '&.Mui-completed': { color: '#004A99' },
                    }
                  }}
                  sx={{
                    cursor: "pointer",
                    '& .MuiStepLabel-label': {
                      mt: 1,
                      fontSize: '0.875rem',
                      fontWeight: activeStep === index ? 600 : 400,
                      color: activeStep === index ? '#004A99' : 'text.secondary',
                    },
                  }}
                >
                  {step.label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
  );
}
